import styled, { css } from 'styled-components';
import { TamanhosCartaz } from '../Cartaz';

export const Container = styled.div<{
  $ranking: boolean;
  $tamanhoCartaz: TamanhosCartaz;
}>`
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  ${({ $ranking, $tamanhoCartaz, theme }) => {
    if ($ranking)
      return css`
        width: 100%;
        height: 100%;
      `;

    return css`
      width: ${theme.tamanhoCartaz.width[$tamanhoCartaz]}px;
    `;
  }}
`;

export const ContainerTitulo = styled.div<{ $ranking: boolean }>`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  flex: 1;

  ${({ $ranking, theme }) => {
    if (!$ranking)
      return css`
        gap: ${theme.spacing[1]}px;
        align-items: center;
      `;
    return css`
      gap: ${theme.spacing[4]}px;
    `;
  }}
`;

export const ContainerInformacoesTitulo = styled.div<{ $ranking: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex: 1;

  ${({ $ranking, theme }) => {
    if (!$ranking)
      return css`
        gap: ${theme.spacing[1]}px;
      `;
    return css`
      gap: ${theme.spacing[4]}px;
    `;
  }}
`;

export const ContainerRanking = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[4]}px;
  align-items: center;
`;

export const NomeTitulo = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  margin-top: 'auto';
  margin-bottom: 'auto';
`;
